import { usePathCheck } from "@/hooks/usePathCheck";
import { cn } from "@/lib/utils";
import { ClassAttributes, HTMLAttributes } from "react";

import { SideFooter } from "./Footer";
import { NavMenu } from "./NavMenu";

export const SideBar = ({
    className,
    ...props
}: ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement>) => {
    const isMypage = usePathCheck("/mypage");
    const isMypageOrders = usePathCheck("/mypage/orders");
    const isMypageCourses = usePathCheck("/mypage/courses");
    return (
        <aside
            className={cn(
                `sticky left-0 top-[var(--header-height)]
                mr-[var(--sidebar-margin)] flex h-[calc(100vh-120px)]
                w-[var(--sidebar-width)] flex-col justify-between gap-6`,
                className,
                isMypage || isMypageOrders || isMypageCourses
                    ? "-mt-[30px]"
                    : "-mt-[62px]"
            )}
            {...props}
        >
            <NavMenu showSubMenu />
            <SideFooter />
        </aside>
    );
};
